import { Component, ElementRef, OnInit, Output, EventEmitter, ViewChild, OnDestroy, AfterViewInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'search-bar',
    templateUrl: './search-bar.component.html',
    styleUrls: ['./search-bar.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchBarComponent implements OnInit, AfterViewInit, OnDestroy {

	@ViewChild('searchInput', { static: false }) searchInput: ElementRef;
	@Input() maxwidth?: number = null;
	@Input() height?: number = null;
	@Input() name?: string = null;
	@Input() placeholder?: string = null;
	@Input() autoFocus: boolean = true;
	@Output() onChanges = new EventEmitter<string>();

	value: string = '';

	blur() {
		this.onChanges.emit(this.value)
	}

	constructor() { }

	ngOnInit() {
	}

	ngAfterViewInit() {
		if (this.autoFocus) {
			this.searchInput.nativeElement.focus();
		}
	}

	ngOnDestroy() {
		if (this.value != '') {
			this.onChanges.emit('');
		}
	}

}
